import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, withState } from 'recompose'

import { api as enrichmentAPI } from 'app/modules/enrichment/api'
import { fetchEnrichedCompanyData } from 'app/modules/enrichment/actions'
import {
  companyDataJS,
  isCompanyDataLoaded,
  isCompanyDataLoading,
} from 'app/modules/enrichment/selectors'
import { getClearbitRevealContext } from 'app/modules/enrichment/clearbit/selectors'
import { isIntegrationConnected } from 'utils/Integrations'

const mapStateToProps = (state, props) => {
  const ip = props.ip
  const email = props.email

  const revealContext = getClearbitRevealContext(state)

  return {
    ip,
    email,
    revealContext,
    companyData: companyDataJS(state, { ip, email }),
    hasDemandbase: isIntegrationConnected('demandbase'),
    isCompanyDataLoaded: isCompanyDataLoaded(state, { ip, email }),
    isCompanyDataLoading: isCompanyDataLoading(state, { ip, email }),
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  actions: bindActionCreators(
    {
      fetchEnrichedCompanyData,
      ...props.actions
    },
    dispatch
  ),
})

const tryFetchCompanyData = (props) => {
  const { ip,
    email,
    actions,
    companyData,
    revealContext,
    hasDemandbase,
    conversationId,
    isCompanyDataLoaded,
    isCompanyDataLoading,
  } = props

  function hasMandatoryDataForFetch(ip, email) {
    return !!ip || !!email
  }

  if (!!companyData || (!hasMandatoryDataForFetch(ip, email))) {
    return
  }

  if ((hasDemandbase || revealContext.conversationsReveal || revealContext.isDriftIntelTrialActive) &&
    (!isCompanyDataLoaded && !isCompanyDataLoading)) {
    actions.fetchEnrichedCompanyData({ ip, email, conversationId, keepEmpty: true, ignoreForwardingFor: true })
  } else if (revealContext.hasProReveal && !revealContext.isDriftIntelTrialActive) {
    enrichmentAPI.fetchDriftIntelTrialEligibility({ ip, email })
      .then((response) => props.setTrialEligible(response))
  }
}

const withEnrichedCompanyData = WrappedComponent =>
  compose(
    connect(mapStateToProps, mapDispatchToProps),
    withState('isTrialEligible', 'setTrialEligible', undefined),
    lifecycle({
      componentDidUpdate(prevProps) {
        if (prevProps.ip !== this.props.ip ||
          prevProps.email !== this.props.email) {
          tryFetchCompanyData(this.props)
        }
      },
      componentDidMount() {
        tryFetchCompanyData(this.props)
      },
    })
  )(WrappedComponent)

export default withEnrichedCompanyData



// WEBPACK FOOTER //
// ./src/scripts/components/hocs/withEnrichedCompanyData.js